// @flow

/**
 * Module dependencies.
 */

import { List, ListItem } from 'client/components/core/lists';
import { compose, defaultProps } from 'recompose';
import { media } from 'client/styles';
import Languages from 'client/components/core/languages';
import LoginButton from 'client/components/navbar/login-button';
import React from 'react';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  fixed: boolean,
  loginLabel: string,
  openMenu: boolean
};

/**
 * `StyledList` styled component.
 */

const StyledList = styled(List)`
  ${media.min.md`
    display: flex;
    white-space: nowrap;
  `}
`;

/**
 * `StyledListItem` styled component.
 */

const StyledListItem = styled(ListItem)`
  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

/**
 * `MenuRight` component.
 */

function MenuRight(props: Props): React$Element<*> {
  const { fixed } = props;

  return (
    <StyledList>
      <StyledListItem>
        <LoginButton fixed={fixed} />
      </StyledListItem>

      <StyledListItem>
        <Languages fixed={fixed} />
      </StyledListItem>
    </StyledList>
  );
}

/**
 * Export `MenuRight`.
 */

export default compose(
  defaultProps({
    openMenu: false
  })
)(MenuRight);



// WEBPACK FOOTER //
// ../src/client/components/navbar/menu-right.js